import { watch, computed } from 'vue';
import { useModalOverlayStore } from '@nuxt-common/atomic-ui/app/stores/useModalOverlayStore';
import type { ModalName } from '~/declaration/modals';

export default function useOnModalChange(modalName: ModalName, { onShow, onClose }: { onShow?: () => void; onClose?: () => void } = {}) {
  const modalOverlayStore = useModalOverlayStore();

  const modal = computed(() => {
    const key = Object.keys(modalOverlayStore.showModal)[0];
    return modalOverlayStore.showModal[key] && key === modalName;
  });

  watch(modal, (isVisible: boolean) => {
    if (isVisible) {
      onShow?.();
    } else {
      onClose?.();
    }
  });
}
